import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-set-goals-targets',
  templateUrl: './set-goals-targets.component.html',
  styleUrls: ['./set-goals-targets.component.scss']
})
export class SetGoalsTargetsComponent implements OnInit {

  constructor() { }
  appsUrl = environment.CMS_APPS_URL;
  signUrl = environment.WEB_URL;
  ngOnInit(): void {
  }

}
